var orderBy = require('./orderBy')

var sortBy = orderBy

module.exports = sortBy



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/sortBy.js
// module id = 0tNC
// module chunks = 141